import { Component, Inject } from '@angular/core'
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar'
import { Observable, Subject } from 'rxjs'

@Component({
  selector: 'gb-yes-no-snack-bar',
  templateUrl: './gb-yes-no-snack-bar.component.html',
  styleUrls: ['./gb-yes-no-snack-bar.component.scss'],
})
export class GbYesNoSnackBarComponent {
  private actionSubject = new Subject<boolean>()

  constructor(
    private snackBarRef: MatSnackBarRef<GbYesNoSnackBarComponent>,
    @Inject(MAT_SNACK_BAR_DATA) public data: { message: string },
  ) {}

  action(result: boolean): void {
    this.actionSubject.next(result)
    this.snackBarRef.dismiss()
  }

  getActionObservable(): Observable<boolean> {
    return this.actionSubject.asObservable()
  }
}
